<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-5 w-full px-3 lg:px-10">
          <div class="mt-10 pb-2 flex justify-between">
            <div class="">
              <p class="text-lg text-blues font-semibold">
                Feedback
                <span v-if="feedback_count != null">
                  ({{ feedback_count }})
                </span>
              </p>
            </div>
            <button
              @click="$router.go(-1)"
              class="bg-blues hover:bg-blue-600 text-xs font-bold text-white px-5 py-1.5 rounded-full"
            >
              Back
            </button>
          </div>

          <div
            class="w-full bg-[#edf8ff] flex justify-center gap-5 items-center px-2 py-2 lg:px-8 rounded-md"
            v-if="response_message"
          >
            <h2 class="text-blues text-center">
              {{ response_message }}
            </h2>

            <router-link
              :to="{ name: 'DownloadHistory' }"
              class="text-blue-600 text-xs underline font-bold"
            >
              Download History
            </router-link>
          </div>
          <div class="flex flex-col gap-5">
            <div class="flex flex-wrap gap-4 justify-end">
              <div class="flex flex-wrap gap-2 w-full md:w-[160px]">
                <select
                  ref="selectFilter"
                  name="model_select"
                  id="model_select"
                  v-model="selected_filter"
                  @change="getfeedback(1)"
                  class="w-full px-4 py-2 rounded-xl text-xs border border-slate-200 bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                >
                  <option value="" disabled selected>Select sorting</option>
                  <option value="text">A to Z</option>
                  <option value="-text">Z to A</option>
                </select>
              </div>
              <div class="relative w-full md:max-w-44">
                <form @submit.prevent="getfeedback(1)">
                  <div
                    class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4 text-gray-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                  <input
                    type="text"
                    placeholder="Search"
                    id="search"
                    v-model="searching"
                    @input="getfeedback(1)"
                    class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-xs text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  />
                  <button
                    v-if="searching"
                    @click="clearSearch"
                    class="absolute inset-y-0 right-0 pr-3 flex items-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4 text-gray-400 hover:text-gray-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </form>
              </div>
              <div>
                <button
                  @click="clearFilters"
                  class="ml-2 px-3 py-1 bg-blues text-white hover:bg-blue-600 rounded-2xl"
                >
                  Clear
                </button>
              </div>
              <button
                type="button"
                class="px-5 py-1 rounded-2xl font-semibold text-sm flex items-center gap-2 transition-all duration-200"
                @click="feedget()"
                :disabled="feedback_list.length === 0"
                :class="[
                  feedback_list.length > 0
                    ? 'bg-blues hover:bg-blue-700 cursor-pointer text-white'
                    : 'bg-gray-300 cursor-not-allowed text-gray-500',
                ]"
              >
                <img src="@/assets/newd/download1.png" alt="" />
                <p class="text-sm">Download</p>
              </button>
            </div>
            <div>
              <div
                class="w-full overflow-x-auto rounded-xl border border-gray-200 shadow-sm bg-white"
              >
                <table
                  class="min-w-full divide-y divide-gray-200 text-sm overflow-visible"
                >
                  <thead class="bg-gray-50 text-blues">
                    <tr>
                      <th
                        class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                      >
                        S NO
                      </th>
                      <th
                        class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                      >
                        Title
                      </th>
                      <th
                        class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                      >
                        Feedback Count
                      </th>
                      <th class="px-6 py-3.5 font-semibold text-center">
                        Averge Ratings
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="feedback_list.length > 0">
                    <tr
                      v-for="(feedback, index) in feedback_list"
                      :key="feedback"
                      class="cursor-pointer hover:bg-gray-100 text-xs"
                    >
                      <td class="p-4 border-b text-center border-r">
                        <p class="text-primary">
                          {{ (currentPage - 1) * pageSize + index + 1 }}
                        </p>
                      </td>
                      <td
                        class="p-4 border-b text-center border-r lg:max-w-[400px]"
                      >
                        <p class="text-primary line-clamp-3">
                          {{ feedback.quiz_title }}
                        </p>
                      </td>
                      <td class="p-4 border-b text-center border-r">
                        <p class="text-primary">
                          {{ feedback.feedback_count }}
                        </p>
                      </td>
                      <td class="p-4 border-b text-center border-r">
                        <div class="text-sm font-bold text-blues">
                          <div
                            class="flex gap-2 items-center flex-wrap justify-center"
                          >
                            <div class="flex justify-center gap-1">
                              <template v-for="i in 5" :key="i">
                                <svg
                                  :class="[
                                    'w-6 h-6 transition',
                                    i <= feedback.average_rating
                                      ? 'text-yellow-400'
                                      : 'text-gray-300',
                                  ]"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.975a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.39 2.46a1 1 0 00-.364 1.118l1.287 3.976c.3.921-.755 1.688-1.538 1.118l-3.39-2.46a1 1 0 00-1.176 0l-3.39 2.46c-.783.57-1.838-.197-1.538-1.118l1.287-3.976a1 1 0 00-.364-1.118L2.05 9.402c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.975z"
                                  />
                                </svg>
                              </template>
                            </div>
                            <p>{{ feedback.average_rating }} Out of 5</p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="6" class="px-6 py-3 text-center">
                        No Data Found
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
              >
                <!-- PAGE SIZE -->
                <div
                  class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
                >
                  <span class="flex md:hidden">Rows per page:</span>
                  <select
                    v-model="pageSize"
                    @change="onPageSizeChange"
                    class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                  </select>
                </div>
              </div>
              <div class="flex justify-center">
                <Pagination
                  :totalPages="totalPages"
                  ref="paginationRef"
                  @page-changed="this.getfeedback"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Instructor/SideBar.vue";
import Pagination from "@/components/Pagination.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  components: {
    SideBar,
    Pagination,
  },
  data() {
    return {
      messages: {
        text: "",
        type: "null",
      },
      pageSize: 10,
      feedback_list: [],
      searching: "",
      selected_filter: "",
      feedback_count: null,
      totalPages: 1,
      current_page: 1,
      response_message: "",
    };
  },
  created() {
    this.getfeedback(1);
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  props: ["course_id"],
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    handleClickOutside(event) {
      const select = this.$refs.selectFilter;
      if (select && !select.contains(event.target)) {
        this.selected_filter = "";
      }
    },
    onPageSizeChange() {
      this.current_page = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.current_page = 1;
      }
      this.getfeedback(1);
    },
    clearFilters() {
      this.selected_filter = "";
      this.selectedRating = "";
      this.searching = "";
      this.getfeedback(1);
    },
    clearSearch() {
      this.searching = "";
      this.getfeedback(1);
    },
    async getfeedback(page) {
      this.currentPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/quiz-feedback/summary/course/${this.course_id}/?Key=${this.userInfo.token_key}&page=${page}&search=${this.searching}&page_size=${this.pageSize}&ordering=${this.selected_filter}`,
        )
        .then((res) => {
          if (res.data.data.status === 200) {
            this.feedback_list = res.data.data.data;
            this.feedback_count = res.data.data.count;
            this.totalPages = res.data.total_page;
            this.current_page = res.data.current_page;
            console.log("this.feedback_list123", this.feedback_list);
          }
        });
    },
    async feedget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/quiz-feedback/download/?course_id=${this.course_id}&Key=${this.userInfo.token_key}`,
        )
        .then((resp) => {
          if (resp) {
            this.response_message =
              "Your file is ready to download go to download history page";

            setTimeout(() => {
              this.response_message = "";
            }, 5000);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
